<div class="row">
  <div class="col-12" style="height: 90vh !important; overflow: auto">
    <form [formGroup]="AddQuestionBodyform">
      <!-- <div class="row p-3">
      <div class="col-12 px-3">
        <div class="d-flex">
          <div class="px-1">

            <button type="button"  class="btn btn-sm bg-light border">Add Text</button>
          </div>

        </div>
      </div>
    </div>
    <div class="row">
    <div class="col-12 text-right">
      <div class="row">
        <div class="col-11 px-3">
          <textarea maxlength="4000"
            class="form-control input-txt1" (ngModelChange)="Descriptioncount()" formControlName="Question_Body_Text" id="txtdescription"></textarea>
            <label class="form-check-label maxlength" for="exampleCheck1">Characters {{Descriptionvaluelength}}/{{DescriptionMaxlength}}</label>

        </div>
      </div>
    </div>
    </div>
    <div class="row p-3">
      <div class="col-12">
        <div class="d-flex">
          <div class="px-1">

            <button type="button" class="btn btn-sm bg-light border">Add Image</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-7 px-3">
            <textarea
              class="form-control input-txt1" id="txtdescription"></textarea>

          </div>
          <div class="col-4">
                <div class="d-flex pt-2">
                  <div class="px-1">

                    <button type="button" class="btn btn-sm bg-light border">Browse</button>
                  </div>

              </div>
          </div>
        </div>
      </div>
      </div> -->
      <!-- <app-quill-rte [RTEFlag]="RTEFlag" (GetLatexBodyContentchanges)="GetLatexBodyContentchanges($event)"(RemoveLatexBodyContent)="RemoveLatexBodyContent($event)" (GetLatexBodyContent)="GetLatexBodyContent($event)" (GetQuestionBodyContent)="GetQuestionBodyContent($event)" [QuestionBodyget]="QuestionBodyget"></app-quill-rte> -->
      <app-tinymce
        [RTEFlag]="RTEFlag"
        (GetLatexBodyContentchanges)="GetLatexBodyContentchanges($event)"
        (GetQuestionBodyContent)="GetQuestionBodyContent($event)"
        [QuestionBodyget]="QuestionBodyget"
      ></app-tinymce>
    </form>
    <!-- <div class="row" *ngIf="latexeditlist.length>0">
        <div class="col-12 headersize">
           Latex Equation List
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr class="table-secondary table-bordered border-secondary">
                    <th class="col-md-1"></th>

                    <th class="col-md-6">Latex Formula</th>
                    <th class="col-md-5">Equation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-secondary table-bordered border-secondary" *ngFor="let s of latexeditlist;let i=index">
                    <td>
                      <div class="d-flex pt-1">


                 
                        <div class="px-3  tree-btn-1" >
                          <button type="button" class="tree-btn" (click)="copyInput(i)">
                              <i class="fa fa-copy" title="Copy"></i>
                          </button>
                        </div>
                         <div class="px-3  tree-btn-1">
                          <button type="button" class="tree-btn" (click)="Editlatexbutton(i)">
                              <i class="fa fa-edit" title="Edit"></i>
                          </button>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div><input type="text" [attr.disabled]="true" class="form-control form-control-sm" [(ngModel)]="s.latex" (ngModelChange)="Editlatex($event,i)"></div>
                    </td>
                    <td>
                      <div class="ql-editor py-1" >
                        <span contenteditable="false" class="ql-mathjax" >
                          <div [innerHTML]="s.mathjax">

                          </div>
                        </span>

                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
      </div>
    </div>
        </div>
      </div> -->
    <form [formGroup]="AddQuestionBodyform">
      <div class="row p-3">
        <div class="col-12 px-3">
          <div class="d-flex">
            <div class="px-1">
              <button
                type="button"
                [disabled]="!AddQuestionBodyform.valid"
                (click)="SaveQuestionBody()"
                class="btn btn-sm bl-btn"
              >
                Save
              </button>
            </div>

            <div class="px-1">
              <button
                type="button"
                (click)="Cancel()"
                class="btn btn-sm bg-light border"
              >
                Cancel
              </button>
            </div>
            <div class="px-1">
              <button
                type="button"
                (click)="RedirecttoAnswer()"
                class="btn btn-sm bg-light border"
              >
                Go to Answers
              </button>
            </div>
            <div class="px-1">
              <button
                type="button"
                (click)="RedirecttoPreview()"
                class="btn btn-sm bg-light border"
              >
                Preview
              </button>
            </div>
            <!-- <div class="px-1">

              <button type="button" (click)="ExtractQuestion()" class="btn btn-sm bg-light border">Extract Question</button>
            </div> -->
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div
  class="modal fade show modal-dialog-centered"
  style="padding-right: 4px; display: block; background-color: #00000075"
  *ngIf="alertpopupflag"
>
  <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Save Changes</h6>
        <button
          type="button"
          class="close"
          style="padding-right: 20px; font-size: 30px; outline: 0"
          (click)="Alertpopup()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Would you like to Save Changes ?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bl-btn"
                  (click)="Savecontent()"
                >
                  Save
                </button>
              </div>
              <div class="px-1">
                <button
                  type="button"
                  class="btn btn-sm bg-light border"
                  (click)="close()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="modal fade  show Model_popup1" *ngIf="editlatexbutton">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Edit Latex Text</h6>
        <button type="button" class="close"
          (click)="closelatexpopup()" style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row">

          <div class="col-12" style="height: 55vh !important; overflow: auto;">
            <div class="row">
              <div class="col-12">
                <div class="row">


                  <div class="row">

                    <div class="col-5 headersize">
                      Enter latex formula
                    </div>
                    <div class="col-7">

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <textarea  style="height: 40vh;" [(ngModel)]="getlatex"
                      class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="row">

                        <div class="col-12 px-2 pt-2">
                          <div class="d-flex">
                            <div class="px-1">

                              <button type="button"  class="btn btn-sm bl-btn" (click)="Savelatex()">Accept</button>
                            </div>

                            <div class="px-1">

                              <button type="button" class="btn btn-sm bg-light border" (click)="LatexpopupCancel()">Cancel</button>
                            </div>


                          </div>
                        </div>


                  </div>



              </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="latexalert">
          <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header border Page-Header p-1 py-0">
                <h6 class="HeadContent" id="QuestionTemplatetitle">Save Changes</h6>
                <button type="button" class="close"
                  style="padding-right: 20px;font-size: 30px;outline: 0;" (click)="latexAlertpopup()">
                  <span aria-hidden="true">&times;</span></button>
              </div>

              <div class="modal-body px-3 py-0">
                <div class="row py-2 mx-2 pt-3">
                  <div class="col-12">
                    <label>Would you like to Save Changes ?</label>
                  </div>
                </div>
                <div class="row p-1">
                  <div class="col-12">
                    <div class="d-flex justify-content-center">
                      <div class="px-1">
                        <button type="button"  class="btn btn-sm bl-btn" (click)="Savelatexcontent()" >Save</button>
                      </div>
                      <div class="px-1">
                        <button type="button"  class="btn btn-sm bg-light border" (click)="closelatex()">Cancel</button>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
